module.exports = __webpack_public_path__ + "img/service-other-content-contact@3x.6a908541.png";